var map = {
	"./aboutus.svg": "5c41",
	"./address.svg": "dd1b",
	"./agreement.svg": "4c29",
	"./alipay.svg": "0e62",
	"./bankcard.svg": "9dd2",
	"./bankcard2.svg": "779d",
	"./bm.svg": "1456",
	"./camera.svg": "b3c4",
	"./coupon.svg": "f615",
	"./default.svg": "3ab4",
	"./down.svg": "7b23",
	"./dvip.svg": "9e36",
	"./dz.svg": "0d54",
	"./eye-close.svg": "7491",
	"./eye-open.svg": "70f4",
	"./fahuo.svg": "116a",
	"./favorite.svg": "dd68",
	"./gwc.svg": "730d",
	"./gywm.svg": "17de",
	"./gzzx.svg": "1545",
	"./jf.svg": "31d9",
	"./kh.svg": "9d60",
	"./kwgl.svg": "1c3d",
	"./money.svg": "9496",
	"./notify.svg": "ce35",
	"./notify2.svg": "2530",
	"./order.svg": "4503",
	"./orderlist.svg": "2fbe",
	"./password.svg": "3bae",
	"./password2.svg": "d9d3",
	"./points.svg": "2b50",
	"./privacy.svg": "4ae2",
	"./sc.svg": "aa5e",
	"./service.svg": "04a2",
	"./settings.svg": "1f0e",
	"./share.svg": "af36",
	"./share2.svg": "1e88",
	"./shopcart.svg": "2558",
	"./sj.svg": "8643",
	"./sq.svg": "866d",
	"./sqbm.svg": "5a04",
	"./tjr.svg": "29dd",
	"./train.svg": "3e4e",
	"./train2.svg": "a0f7",
	"./up.svg": "1df8",
	"./upload.svg": "93a9",
	"./user.svg": "d710",
	"./username.svg": "fb73",
	"./vip.svg": "450c",
	"./waitdelv.svg": "e5a3",
	"./waitdone.svg": "475b",
	"./waitpay.svg": "0df7",
	"./waitrecv.svg": "49d9",
	"./wechat.svg": "a1f4",
	"./yaddress.svg": "ca9c",
	"./yarticle.svg": "0eee",
	"./ycomplete.svg": "93b8",
	"./yfahuo.svg": "291b",
	"./ygroup.svg": "abb5",
	"./yhq.svg": "cd1b",
	"./ymobile.svg": "44d7",
	"./ymygroup.svg": "e102",
	"./yorder.svg": "aed3",
	"./ypassword.svg": "9af4",
	"./ypoints.svg": "d338",
	"./yq.svg": "dff7",
	"./ysetting.svg": "b406",
	"./yshare.svg": "520d",
	"./ysharer.svg": "55f2",
	"./yshop.svg": "e52a",
	"./yuser.svg": "9f40",
	"./ywaitfahuo.svg": "4109",
	"./ywaitpay.svg": "4cb6",
	"./ywaitrecv.svg": "a079",
	"./yzm.svg": "19af",
	"./zhlogin.svg": "a96c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fcb1";